import React from 'react';
import {Table} from '../../../components/table/Table';
import {useInvoke} from '../../../controllers/useInvoke';

const TITLE = {
  field: 'video_title',
  header: 'Title',
};

const URL = {
  field: 'video_link',
  header: 'URL',
};

const CREATEDON = {
  type: 'date',
  field: 'created_on',
  header: 'Created On',
};

const COMPLETEDON = {
  type: 'date',
  field: 'completed_date',
  header: 'Completed Date',
};

export const VideoActiveTable = props => {
  const {
    route: {params},
    navigation,
    searchValue,
  } = props;
  const {communicationFilter} = params;
  const invoke = useInvoke({method: 'put'});
  const markComplete = ({row}) => {
    invoke({
      uri: `/videos/${row?._id}`,
      props: {
        status: 'completed',
        completed_date: new Date(),
      },
    });
  };
  return (
    <Table
      search={searchValue}
      searchFields={'video_title'}
      api={`/video-ads`}
      addOnFilter={{
        status: 'active',
        ...communicationFilter,
      }}
      params={params}
      onRowPress={row => {
        navigation.navigate('edit-video-ad', row);
      }}
      columns={[
        TITLE,
        URL,
        CREATEDON,
      ]}
      moreActions={[
        {
          title: 'Mark Completed',
          onPress: markComplete,
        },
      ]}
    />
  );
};

export const VideoCompletedTable = ({route: {params}, searchValue}) => {
  const {communicationFilter} = params;
  return (
    <Table
      search={searchValue}
      searchFields={'video_title'}
      api={`/video-ads`}
      addOnFilter={{
        status: 'completed',
        ...communicationFilter,
      }}
      params={params}
      columns={[TITLE, URL, CREATEDON, COMPLETEDON]}
    />
  );
};
